import MDEditor, { ICommand } from "@uiw/react-md-editor";

import { CustomInput, InputType } from "@/ui-components/commonComponents/Input/Input";

export const INPUT_MAX_LENGTH: number = 1000;

interface MarkdownFieldProps {
  value?: string;
  onChange?: (value?: string) => void;
  disabled?: boolean;
  height?: number;
  // Forwarded to MDEditor; omit for its defaults (full toolbar, split "live" preview).
  commands?: ICommand[];
  extraCommands?: ICommand[];
  preview?: "edit" | "live" | "preview";
  textareaProps?: {
    id?: string;
    placeholder?: string;
    maxLength?: number;
    "aria-label"?: string;
    "aria-describedby"?: string;
  };
}

// Shared markdown editor for admin text fields: common max length, placeholder, and "links open in a new
// tab" preview. Works as a Form.Item child or with explicit value/onChange; read-only when disabled.
export function MarkdownField({
  value = "",
  onChange,
  disabled = false,
  height,
  commands,
  extraCommands,
  preview,
  textareaProps,
}: MarkdownFieldProps) {
  if (disabled) {
    return (
      <CustomInput
        placeholder="Type..."
        inputType={InputType.textarea}
        disabled
        value={value}
        aria-label={textareaProps?.["aria-label"]}
      />
    );
  }

  return (
    <MDEditor
      highlightEnable={false}
      height={height}
      value={value}
      onChange={onChange}
      preview={preview}
      commands={commands}
      extraCommands={extraCommands}
      textareaProps={{ maxLength: INPUT_MAX_LENGTH, placeholder: "Type...", ...textareaProps }}
      previewOptions={{
        components: {
          a: ({ node, children, ...props }) => (
            <a target="_blank" rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
        },
      }}
    />
  );
}

export default MarkdownField;
